import React from "react";
import { Trans } from "react-i18next";
import { IconStepCheck, IconStepError, IconStepLoading, IconStepReload } from "@icons/index";
import "./index.scss";
import CommonButton from "@components/CommonButton";
import classNames from "classnames";

// SVG ICONS
const icons = {
  succeeded: <IconStepCheck className="w-[16px] h-[16px]" />,
  loading: <IconStepLoading className="w-[16px] h-[16px] animate-spin" />,
  failed: <IconStepError className="w-[16px] h-[16px]" />,
};

interface ProgressItemProps {
  icon: React.ReactNode;
  label: React.ReactNode;
  status: Status;
  onRetry?: () => void;
}

export const ProgressItem: React.FC<ProgressItemProps> = ({ icon, label, status = "loading", onRetry }) => {
  return (
    <div
      className={`flex items-center gap-[4px] px-4 py-3 rounded-lg transition-all text-kds-fg`}
      style={{ minHeight: 52 }}
    >
      <span className={classNames("flex items-center justify-center w-[24px] h-[24px] rounded-full bg-kds-bg-subtle")}>
        {icon}
      </span>
      <span className="flex-1 text-base flex items-center gap-[4px] font-normal">
        {status === "failed" ? (
          <>
            <Trans>Oops! Something went wrong. Retry</Trans>
            <CommonButton className="rounded-full! ml-[16px]" onClick={onRetry}>
              <IconStepReload className="w-[16px] h-[16px]" />
              <Trans>Retry</Trans>
            </CommonButton>
          </>
        ) : (
          <Trans>{label}</Trans>
        )}
      </span>
      <span className="flex items-center justify-center w-6 h-6">{icons[status as keyof typeof icons]}</span>
    </div>
  );
};
